export default "__VITE_ASSET__LPe_kfyV__"